module.exports = __webpack_public_path__ + "static/people-5cca32dda55cbbe3a65ccec77dcc92a9.svg";